/**
 * Tipos de ocorrência do histórico da compra: bloco comum 1 a 9 e específicos a partir de 20.
 * Espelha tipo_ocorrencia_compra (db_compras) e TipoOcorrenciaCompraEnum (API Compras); também é o
 * gatilho das automações. Nome e ícone vêm do catálogo no struct da ocorrência.
 */
export enum TipoOcorrenciaCompraEnum {
  Criacao = 1,
  Edicao = 2,
  MudancaEtapa = 3,
  Exclusao = 4,
  Anotacao = 5,
  Liberacao = 6,
  IntegracaoLancada = 7,
  IntegracaoExcluida = 8,
  FalhaIntegracao = 9,
  Aprovacao = 20,
  Reprovacao = 21,
  Cancelamento = 22,
  Anexo = 23,
  EnvioCotacao = 24,
  EnvioPedidoFornecedor = 25,
  VinculoNFeEntrada = 26,
  InicioConferencia = 27,
  ConclusaoConferencia = 28,
  DivergenciaRegistrada = 29,
  Devolucao = 30,
  Finalizacao = 31,
  NotificacaoAprovadores = 32,
  GeracaoPedidos = 33,
  AutomacaoExecutada = 34,
  AutomacaoFalhou = 35,
}
